import { Body, Box, Divider } from '@hover/blueprint';
import React, { useState } from 'react';
import { DownloadAppModal } from '../../../common';

const BasicsFooter: React.FC = () => {
  const [isOpen, setOpen] = useState<boolean>(false);
  const toggleModal = () => setOpen(!isOpen);

  return (
    <>
      <DownloadAppModal isOpen={isOpen} onClose={toggleModal} />
      <Box px={400}>
        <Divider borderColor="neutral.300" mt={500} mb={400} />
      </Box>
      <Box
        flexDir="column"
        alignItems="center"
        px={{ base: 400, desktop: 500 }}
        pb={500}
      >
        <Body size={500} textAlign="center">
          Choose a Pro account to receive measurements. Just looking to design
          your home in 3D?
        </Body>
        <Body
          cursor="pointer"
          size={500}
          isSemiBold
          color="primary.600"
          textAlign="center"
          onClick={toggleModal}
          _hover={{
            color: 'primary.700',
            textDecoration: 'underline',
          }}
        >
          Join as a homeowner and all jobs are free.
        </Body>
      </Box>
    </>
  );
};

export default BasicsFooter;
